import { datadog } from '../../../shared/datadog/datadog';
import { AppThunk } from '../../../store/rootReducer';
import { getEnvironment, identify } from '../../analytics/analytics.utils';
import * as authActions from '../actions/auth.actions';
import { User } from '../types/auth';
import { loadCoworkers } from './load-coworkers.thunk';
import { loadPreferences } from './load-preferences.thunk';

export const loadAfterLogin =
  (user: User, datadogInstance = datadog): AppThunk =>
  async (dispatch) => {
    datadogInstance.setUser({
      id: user.id,
    });

    identify(user.id, {
      user_id: user.id,
      user_role: user.role,
      env: getEnvironment(),
      organization_name: user.organization?.name ?? 'no_organization',
      organization_uuid: user.organization?.id ?? 'no_organization',
    });

    dispatch(loadPreferences(user));
    await dispatch(loadCoworkers(user));
    dispatch(authActions.setUser({ user, meta: { history: false } }));
  };
